import { createFileRoute, Outlet } from '@tanstack/react-router'
import { expenseQueryOptions } from '../../../../features/finance/queries'

export const Route = createFileRoute('/_app/expenses/$expenseId')({
  staticData: { crumb: 'expense' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(expenseQueryOptions(params.expenseId)),
  component: Outlet,
})
